import './Availability.scss'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import moment from 'moment-timezone'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import {
  ChangeDatesTool,
  debounce,
  Dropdown,
  MultiSelectDropdown,
  PageLoadingSpinner,
  useUpdateEffect,
} from 'ui_kit_qmd'
import { findIana } from 'windows-iana'
import { useSearchParams } from 'react-router-dom'
import { ErrorAlert } from '../../components/ui_kit_quickMD/error-alert/erroralert'
import errorIcon from '../../images/common/error-icon.svg'
import AvailabilityTableItem from '../../components/AvailabilityTableItem/AvailabilityTableItem'
import { isEllipsisActive, statesOptions } from '../../utils/commonMembersPage'
import { getAvailabilitiesList } from '../../store/availability/AvailabilityThunk'
import { clearAvailabilitiesList, setAvailabilityPageError } from '../../store/availability/AvailabilitiesActions'

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { AVAILABILITY_LABEL, NO_AVAILABLE_PROVIDER_TABLE_EMPTY_TEXT } from '../../utils/constants'
import { SearchComponent } from '../../components/SearchComponent/SearchComponent'
import TimeZoneSelect from '../../components/time-zone-select/timeZoneSelect'
import {
  generateCorrectDateForCalendar,
  getCorrectViewFormatOfDateInSelectDateTool,
  getValueOfNewSearchParamsByFieldName,
  isValidDate,
  toTimeZone,
  visitTypesNameHandler,
} from './tools'
import { getServiceTypes } from '../../store/management/ManagementThunk'
import { Pagination } from '../../components/pagination/Pagination'
import {
  DEFAULT_DATE_VALUE_FORMAT,
  TIME_FOR_DATE_RANGE_REQUEST_FROM,
  TIME_FOR_DATE_RANGE_REQUEST_TO,
} from '../../utils/dateUtils'
import { setInitialTimeZone } from '../../store/timeZone/timeZoneActions'

const errorToastWrapContainerStyle = {
  marginLeft: 'auto',
  marginRight: 'auto',
  top: 0,
  zIndex: 10,
  position: 'absolute',
  left: 0,
  right: 0,
}

const errorToastContainerStyle = {
  width: 550,
}

const visitTypeDropdownStyleHidden = {
  width: '290px',
  height: 60,
  background: '#FFFFFF',
  borderRadius: 4,
}
const visitTypeDropdownContainerStyle = {
  width: 290,
  maxHeight: 190,
  top: 65,
}

// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const pageContainerStyle = { overflow: 'hidden' }

const availabilityPageStateDropdownOptions = ['All', ...statesOptions]

const getListRequestCount = 20

const COUNT_STEP = 9

const PAGINATION_STATE_INITIAL = {
  leftCount: 0,
  rightCount: COUNT_STEP,
  isNeedToUpdate: false,
}

// @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
const EMPTY_ITEMS = []

const AvailabilityPage = memo(() => {
  const dispatch = useDispatch()
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const listInnerRef = useRef(null)

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.accountSettings.adminProfile)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.availabilityPage.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.availabilityPage.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const lastListIncrease = useSelector((state) => state.availabilityPage.lastListIncrease)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const availabilitiesList = useSelector((state) => state.availabilityPage.availabilitiesList?.Items ?? EMPTY_ITEMS)
  const availabilitiesListTotalCount = useSelector(
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    (state) => state.availabilityPage.availabilitiesList?.TotalCount || 0,
  )
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const serviceTypes = useSelector((state) => state.management.serviceTypes)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const timeZoneFromTheStore = useSelector((state) => state.timeZoneReducer.initialTimeZone)
  const [appointmentNameToolTipInfo, setAppointmentNameToolTipInfo] = useState(null)
  const [getListRequestOffset, setGetListRequestOffset] = useState(0)
  const [searchText, setSearchText] = useState('')
  const [isBackButtonPressed, setIsBackButtonPressed] = useState(false)
  const [sortByVisitTypeCondition, setSortByVisitTypeCondition] = useState([])
  const [sortByStateCondition, setSortByStateCondition] = useState('')
  const [visitTypeSortCondition, setVisitTypeSortCondition] = useState('')
  const [sortConditionArray, setSortConditionArray] = useState([])
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [isSortConditionArrayWasChanged, setIsSortConditionArrayWasChanged] = useState(false)
  const [isSidePanelRoutePressed, setIsSidePanelRoutePressed] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [customTimeZone, setCustomTimeZone] = useState(timeZoneFromTheStore ?? currentTimeZone)
  const initialCurrentDate = toTimeZone(new Date(), customTimeZone)
  const [currentDate, setCurrentDate] = useState(initialCurrentDate)
  const [correctAvailabilityList, setCorrectAvailabilityList] = useState([])
  const [paginationState, setPaginationState] = useState(PAGINATION_STATE_INITIAL)
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchParamTimerId, setSearchParamTimerId] = useState(undefined)

  useEffect(() => {
    setSortByStateCondition('All')
    const { date, ...rest } = Object.fromEntries(searchParams)
    setSearchParams(
      {
        ...rest,
        date: date && isValidDate(date) ? date : moment(initialCurrentDate).format('YYYY-MM-DDT00:00:00.000'),
      },
      { replace: true },
    )
  }, [])

  useEffect(() => {
    if (getListRequestOffset === -1) setGetListRequestOffset(0)
    setCorrectAvailabilityList(availabilitiesList?.map(visitTypesNameHandler))
  }, [availabilitiesList])

  useEffect(() => {
    const visitTypesOptions = serviceTypes
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      ?.map((serviceType) =>
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        serviceType.VisitTypes.map((visitType) => ({
          value: `${serviceType.Name} (${visitType.Name})`,
          visitTypeId: visitType.VisitTypeId,
          isActive: false,
        })),
      )
      .flat()
    const { visitTypes } = Object.fromEntries(searchParams)
    let visitTypesArr = []
    try {
      // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
      visitTypesArr = JSON.parse(visitTypes)
    } catch (error) {
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      console.error('Error parsing JSON:', error.message)
    }
    if (visitTypesArr?.length && visitTypesArr && Array.isArray(visitTypesArr)) {
      visitTypesArr.forEach((firstObj) => {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const foundObj = visitTypesOptions.find((secondObj) => secondObj.visitTypeId === firstObj.visitTypeId)
        if (foundObj) {
          foundObj.isActive = true
        }
      })
      setSortConditionArray(
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        visitTypesOptions.filter((visitType) => visitType.isActive).map((visitType) => visitType.visitTypeId),
      )
    }

    setSortByVisitTypeCondition(visitTypesOptions)
  }, [serviceTypes])

  useEffect(() => {
    dispatch(clearAvailabilitiesList())
  }, [currentDate, dispatch])

  useEffect(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getServiceTypes())
  }, [dispatch])

  useUpdateEffect(() => {
    if (paginationState.rightCount && paginationState.isNeedToUpdate) {
      dispatch(
        getAvailabilitiesList({
          offset: paginationState.leftCount,
          count: COUNT_STEP,
          fromDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
          toDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_TO),
          searchText,
          sortConditionArray,
          sortByStateCondition,
        }),
      )
    }
  }, [dispatch, paginationState])

  useEffect(() => {
    if (!isSidePanelRoutePressed && !isFirstRender && !isBackButtonPressed) {
      setGetListRequestOffset(-1)
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (listInnerRef.current) listInnerRef.current.scroll(0, 0)
      if (sortByStateCondition) {
        setPaginationState(PAGINATION_STATE_INITIAL)
        dispatch(
          getAvailabilitiesList({
            offset: 0,
            count: COUNT_STEP,
            fromDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
            toDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_TO),
            searchText,
            sortConditionArray,
            isSortReset: true,
            sortByStateCondition,
          }),
        )
      }
    }
    setIsBackButtonPressed(false)
    setIsSidePanelRoutePressed(false)
    setIsFirstRender(false)
  }, [sortByStateCondition, currentDate])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setAvailabilityPageError())
      }, 3500)
    }
  }, [dispatch, error])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const mouseOverHandler = useCallback((e, title, type, ItemId) => {
    const toolTipContainerPositionStyle = {
      left: window.innerWidth - e.clientX < 500 ? e.clientX - 640 : e.clientX - 220,
      top: e.clientY > 250 ? e.clientY - 100 : e.clientY + 15,
      wordBreak: 'break-word',
      maxWidth: window.innerWidth - e.clientX < 600 ? 'none' : 450,
      title,
    }
    switch (type) {
      case 'providerName':
        if (isEllipsisActive(document.getElementById(`firstLastNameBlock${ItemId}`))) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setAppointmentNameToolTipInfo(toolTipContainerPositionStyle)
        }
        break
      case 'availabilities':
        if (isEllipsisActive(document.getElementById(`availabilities${ItemId}`))) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setAppointmentNameToolTipInfo(toolTipContainerPositionStyle)
        }
        break
      case 'unavailabilities':
        if (isEllipsisActive(document.getElementById(`unavailabilities${ItemId}`))) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setAppointmentNameToolTipInfo(toolTipContainerPositionStyle)
        }
        break
      case 'licensedStates':
        if (isEllipsisActive(document.getElementById(`licensedStateBlock${ItemId}`))) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          setAppointmentNameToolTipInfo(toolTipContainerPositionStyle)
        }
        break
      case 'visitTypes':
        if (isEllipsisActive(document.getElementById(`visitTypes${ItemId}`))) {
          setAppointmentNameToolTipInfo({
            ...toolTipContainerPositionStyle,
            // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
            maxWidth: 650,
            left: window.innerWidth - e.clientX < 500 ? e.clientX - 940 : e.clientX - 220,
          })
        }
        break
      default:
        break
    }
  }, [])
  const mouseOutHandler = useCallback(() => {
    setAppointmentNameToolTipInfo(null)
  }, [])

  const onTableScrollHandler = useCallback(() => {
    mouseOutHandler()
    if (getListRequestOffset === -1) return
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current
      if (scrollHeight - (scrollTop + clientHeight) < 20) {
        if (!loading && availabilitiesList.length > getListRequestOffset) {
          if (lastListIncrease === getListRequestCount) {
            setGetListRequestOffset((prev) => prev + getListRequestCount)
          }
        }
      }
    }
  }, [availabilitiesList.length, getListRequestOffset, lastListIncrease, loading, mouseOutHandler])

  const availabilityTableBodyStyle = useMemo(
    () => ({
      minHeight: availabilitiesList?.length > 0 ? 175 : 76,
      height: availabilitiesList?.length ? 'auto' : 77,
    }),
    [availabilitiesList],
  )

  const generateItemScheduleTime = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (scheduleArray) => {
      if (scheduleArray) {
        const arrOfCorrectScheduleFormat = scheduleArray.map(
          // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
          ({ FromDateTime, ToDateTime, StateCodes }) =>
            `${toTimeZone(FromDateTime, customTimeZone).format('hh:mma')} - ${toTimeZone(
              ToDateTime,
              customTimeZone,
            ).format('hh:mma')}${StateCodes?.length ? ` (${StateCodes.join(', ')})` : ''}`,
        )
        return arrOfCorrectScheduleFormat.join('; ')
      }
      return ''
    },
    [customTimeZone],
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const generateLicenseStateRow = useCallback((states) => {
    if (states?.length) {
      return states?.join('; ')
    }
    return '--'
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const generateVisitTypesRow = useCallback((visitTypes) => {
    if (visitTypes?.length) {
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      return visitTypes.map(({ Name }) => Name).join('; ')
    }
    return '--'
  }, [])

  const setDateQuery = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setSearchParams(
        getValueOfNewSearchParamsByFieldName({
          fieldName: 'date',
          queryValue: moment(value).format(DEFAULT_DATE_VALUE_FORMAT),
          searchParams,
        }),
      )
    },
    [searchParams, setSearchParams],
  )

  const setVisitTypeQuery = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      let visitTypesArr = []
      try {
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        visitTypesArr = JSON.parse(value)
      } catch (error) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        console.error('Error parsing JSON:', error.message)
      }
      if (!visitTypesArr.length) {
        setSearchParams(
          getValueOfNewSearchParamsByFieldName({
            fieldName: 'visitTypes',
            queryValue: null,
            searchParams,
          }),
        )
      } else {
        setSearchParams(
          getValueOfNewSearchParamsByFieldName({
            fieldName: 'visitTypes',
            queryValue: value.length ? value : null,
            searchParams,
          }),
        )
      }
    },
    [searchParams, setSearchParams],
  )

  const setSearchTextQuery = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setSearchParams(
        getValueOfNewSearchParamsByFieldName({
          fieldName: 'search',
          queryValue: value.length ? value : null,
          searchParams,
        }),
      )
    },
    [searchParams, setSearchParams],
  )

  const setStateQuery = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setSearchParams(
        getValueOfNewSearchParamsByFieldName({
          fieldName: 'state',
          queryValue: value === 'All' ? null : value,
          searchParams,
        }),
      )
    },
    [searchParams, setSearchParams],
  )

  const onSetCurrentDate = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setCurrentDate(generateCorrectDateForCalendar(value, customTimeZone))
      setDateQuery(generateCorrectDateForCalendar(value, customTimeZone))
    },
    [customTimeZone, setDateQuery],
  )
  const onNextDayClick = useCallback(() => {
    setCurrentDate((prev) => {
      const newDate = moment(prev).add(1, 'days')
      setDateQuery(newDate)
      return newDate
    })
  }, [setDateQuery])

  const onPrevDayClick = useCallback(() => {
    setCurrentDate((prev) => {
      const newDate = moment(prev).subtract(1, 'days')
      setDateQuery(newDate)
      return newDate
    })
  }, [setDateQuery])

  const setConditionValue = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newValue) => {
      setSortByVisitTypeCondition(newValue)
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const activeOptions = newValue.filter((t) => t.isActive)
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const newSortConditionArray = activeOptions.map((t) => t.visitTypeId)
      setSortConditionArray(newSortConditionArray)
      setVisitTypeQuery(
        JSON.stringify(
          // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
          activeOptions?.map(({ visitTypeId }) => ({
            visitTypeId,
          })),
        ),
      )
      setPaginationState(PAGINATION_STATE_INITIAL)
      dispatch(
        getAvailabilitiesList({
          offset: 0,
          count: COUNT_STEP,
          fromDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
          toDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_TO),
          searchText,
          sortConditionArray: newSortConditionArray,
          isSortReset: true,
          sortByStateCondition,
        }),
      )
      setIsSortConditionArrayWasChanged(true)
    },
    [currentDate, dispatch, searchText, setVisitTypeQuery, sortByStateCondition],
  )

  const onSetCurrentDateTimeZone = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setCustomTimeZone(value?.value)
      dispatch(setInitialTimeZone(value?.value))
      setCurrentDate(toTimeZone(new Date(), value?.value))
    },
    [dispatch],
  )

  const getAvailabilityList = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (textValue) => {
      setGetListRequestOffset(-1)
      setPaginationState(PAGINATION_STATE_INITIAL)
      dispatch(clearAvailabilitiesList())
      dispatch(
        getAvailabilitiesList({
          offset: 0,
          count: COUNT_STEP,
          fromDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
          toDateTime: moment(currentDate).format(TIME_FOR_DATE_RANGE_REQUEST_TO),
          searchText: textValue,
          sortConditionArray,
          isSortReset: true,
          sortByStateCondition,
        }),
      )
    },
    [currentDate, dispatch, sortByStateCondition, sortConditionArray],
  )

  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  const getAvailableList = ({ searchText, sortConditionArray, sortByStateCondition, date }) => {
    dispatch(
      getAvailabilitiesList({
        offset: 0,
        count: COUNT_STEP,
        fromDateTime: moment(date).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
        toDateTime: moment(date).format(TIME_FOR_DATE_RANGE_REQUEST_TO),
        searchText,
        sortConditionArray,
        isSortReset: true,
        sortByStateCondition,
      }),
    )
  }

  const getAvailabilityListDebounced = debounce(getAvailabilityList, 500)

  const onChangeSearchText = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (e) => {
      const { search } = Object.fromEntries(searchParams)

      if (searchText.trim().length && e.target.value.trim() === '') {
        setSearchText(e.target.value)
        getAvailabilityListDebounced(e.target.value)
      } else if (e.target.value.trim().length >= 3) {
        setSearchText(e.target.value)
        if (searchParamTimerId) {
          clearTimeout(searchParamTimerId)
        }
        const delayDebounceFn = setTimeout(() => {
          setSearchTextQuery(e.target.value)
          getAvailabilityList(e.target.value)
        }, 500)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setSearchParamTimerId(delayDebounceFn)
      } else {
        setSearchText(e.target.value)
      }
      if (e.target.value.trim().length < 3 && search?.length) {
        setSearchTextQuery('')
      }
    },
    [
      getAvailabilityList,
      getAvailabilityListDebounced,
      searchParamTimerId,
      searchParams,
      searchText,
      setSearchTextQuery,
    ],
  )

  useEffect(() => {
    const { date, search, state } = Object.fromEntries(searchParams)

    if (date && isValidDate(date)) {
      setCurrentDate(generateCorrectDateForCalendar(date, customTimeZone))
    }
    if (search) {
      setSearchText(search)
    }
    if (state && availabilityPageStateDropdownOptions.some((stateName) => stateName === state)) {
      setSortByStateCondition(state)
    }
  }, [])

  useEffect(() => {
    window.onpopstate = () => {
      const { date, search, visitTypes, state } = Object.fromEntries(searchParams)
      setIsBackButtonPressed(true)
      const visitTypesOptions = serviceTypes
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        ?.map((serviceType) =>
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          serviceType.VisitTypes.map((visitType) => ({
            value: `${serviceType.Name} (${visitType.Name})`,
            visitTypeId: visitType.VisitTypeId,
            isActive: false,
          })),
        )
        .flat()

      setSearchText(search ?? '')

      if (isValidDate(date)) {
        setCurrentDate(generateCorrectDateForCalendar(date, customTimeZone))
      } else if (!date) {
        setCurrentDate(generateCorrectDateForCalendar(initialCurrentDate, customTimeZone))
        setDateQuery(generateCorrectDateForCalendar(initialCurrentDate, customTimeZone))
      }
      if (state && availabilityPageStateDropdownOptions.some((stateName) => stateName === state)) {
        setSortByStateCondition(state)
      } else {
        setSortByStateCondition('All')
      }
      let visitTypesArr = []
      let sortConditionArrayForRequest = []
      try {
        // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
        visitTypesArr = JSON.parse(visitTypes)
      } catch (error) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        console.error('Error parsing JSON:', error.message)
      }
      if (visitTypesArr?.length && visitTypesArr && Array.isArray(visitTypesArr)) {
        visitTypesArr.forEach((firstObj) => {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const foundObj = visitTypesOptions.find((secondObj) => secondObj.visitTypeId === firstObj.visitTypeId)
          if (foundObj) {
            foundObj.isActive = true
          }
        })
        const newSortConditionArray = visitTypesOptions
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .filter((visitType) => visitType.isActive)
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          .map((visitType) => visitType.visitTypeId)
        setSortConditionArray(newSortConditionArray)
        sortConditionArrayForRequest = newSortConditionArray
      } else if (!visitTypesArr.length) {
        setSortConditionArray([])
      }

      setSortByVisitTypeCondition(visitTypesOptions)
      getAvailableList({
        searchText: search ?? '',
        sortConditionArray: sortConditionArrayForRequest,
        sortByStateCondition: state,
        date,
      })
    }
  }, [searchParams])

  const availabilityRibbonItems = useMemo(
    () =>
      correctAvailabilityList.map(
        (
          {
            DoctorId,
            FirstName,
            LastName,
            Prefix,
            Suffix,
            StateCodes,
            Unavailability,
            Availability,
            ImageUrl,
            VisitTypes,
            IsActive,
          },
          i,
        ) => (
          <AvailabilityTableItem
            key={DoctorId}
            FirstName={FirstName}
            LastName={LastName}
            Prefix={Prefix}
            Suffix={Suffix}
            ImageUrl={ImageUrl}
            ItemId={DoctorId}
            appointmentNameToolTipInfo={appointmentNameToolTipInfo}
            mouseOverHandler={mouseOverHandler}
            mouseOutHandler={mouseOutHandler}
            LicensedStates={generateLicenseStateRow(StateCodes)}
            Availabilities={generateItemScheduleTime(Availability)}
            Unavailabilities={generateItemScheduleTime(Unavailability)}
            VisitTypes={generateVisitTypesRow(VisitTypes)}
            customTimeZone={customTimeZone}
            isLastElem={i === availabilitiesList.length - 1}
            AccountActive={IsActive}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            searchParams={searchParams}
          />
        ),
      ),
    [
      appointmentNameToolTipInfo,
      availabilitiesList.length,
      correctAvailabilityList,
      customTimeZone,
      generateItemScheduleTime,
      generateLicenseStateRow,
      generateVisitTypesRow,
      mouseOutHandler,
      mouseOverHandler,
      searchParams,
    ],
  )

  const emptyRibbon = useMemo(
    () => <div className='availability-empty-table'>{loading ? '' : NO_AVAILABLE_PROVIDER_TABLE_EMPTY_TEXT}</div>,
    [loading],
  )

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const reloadSection = useCallback(() => {
    dispatch(clearAvailabilitiesList())
    const visitTypesOptions = serviceTypes
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      ?.map((serviceType) =>
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        serviceType.VisitTypes.map((visitType) => ({
          value: `${serviceType.Name} (${visitType.Name})`,
          visitTypeId: visitType.VisitTypeId,
          isActive: false,
        })),
      )
      .flat()
    setSortByStateCondition('All')
    setCurrentDate(initialCurrentDate)
    setSortByVisitTypeCondition(visitTypesOptions)
    setVisitTypeQuery([])
    setSearchText('')
    setSearchTextQuery('')
    searchParams.delete('state')
    searchParams.delete('search')
    searchParams.delete('visitTypes')
    setDateQuery(initialCurrentDate)
    setSortConditionArray([])
    onSetCurrentDateTimeZone({ value: profile.TimeZone ? findIana(profile.TimeZone)[0] : currentTimeZone })
    setIsSidePanelRoutePressed(true)
    dispatch(
      getAvailabilitiesList({
        offset: 0,
        count: COUNT_STEP,
        fromDateTime: moment(initialCurrentDate).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
        toDateTime: moment(initialCurrentDate).format(TIME_FOR_DATE_RANGE_REQUEST_TO),
        searchText: '',
        sortConditionArray: [],
        sortByStateCondition: 'All',
      }),
    )
  }, [
    currentTimeZone,
    dispatch,
    initialCurrentDate,
    onSetCurrentDateTimeZone,
    profile.TimeZone,
    searchParams,
    serviceTypes,
    setDateQuery,
    setSearchTextQuery,
    setVisitTypeQuery,
  ])

  const leftPaginationAction = useCallback(() => {
    setPaginationState((prev) => ({
      leftCount: prev.leftCount - COUNT_STEP,
      rightCount: prev.rightCount - COUNT_STEP,
      isNeedToUpdate: true,
    }))
  }, [])

  const rightPaginationAction = useCallback(() => {
    setPaginationState((prev) => ({
      leftCount: prev.leftCount + COUNT_STEP,
      rightCount: prev.rightCount + COUNT_STEP,
      isNeedToUpdate: true,
    }))
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setStateSortValue = (value) => {
    setSortByStateCondition(value)
    setStateQuery(value)
  }

  return (
    <div>
      {loading ?
        <PageLoadingSpinner />
      : null}
      {error ?
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        <div style={errorToastWrapContainerStyle}>
          {/*
           // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
          <ErrorAlert styleContainer={errorToastContainerStyle} errorText={error} errorImg={errorIcon} imgAlt='Error' />
        </div>
      : null}
      <div className='availability-container'>
        <div className='availability-header-block'>
          <span className='availability-page-title'>Availability</span>
          <div className='availability-page-header-tools-container'>
            <TimeZoneSelect
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              isWithDynamicParentAdjustements
              onSetCurrentDateTimeZone={onSetCurrentDateTimeZone}
              customSelectedTimezone={customTimeZone}
            />
            <ChangeDatesTool
              isWithCalendarSelect
              setCurrentDate={onSetCurrentDate}
              onNextBtn={onNextDayClick}
              onPrevBtn={onPrevDayClick}
              currentDate={getCorrectViewFormatOfDateInSelectDateTool(currentDate)}
            />
          </div>
        </div>
        <div className='availability-table-block'>
          <div className='availability-filter-sort-container'>
            <div className='availability-filter-sort-dropdown-block'>
              <Dropdown
                isWithSearch
                isStateDropdown
                options={availabilityPageStateDropdownOptions}
                containerStyle={visitTypeDropdownStyleHidden}
                dropdownContainerStyle={visitTypeDropdownContainerStyle}
                value={sortByStateCondition}
                setValue={setStateSortValue}
                dropId='stateDropDownAvailability'
                label='State'
              />
              <MultiSelectDropdown
                isWithOptionsSort
                isEmptyMessage
                extraDropDownFieldClass='selectVisitTypeSearchBarAdditionalClass'
                options={sortByVisitTypeCondition}
                setOptions={setConditionValue}
                className='availability-page-visitTypes-dropdown-container'
                value={visitTypeSortCondition}
                setValue={setVisitTypeSortCondition}
                dropId='VisitTypeDropDownAvailability'
                optionsListItemsValueMaxLengthToBeCentered={10}
                label='Visit type'
              />
            </div>
            <SearchComponent
              additionalClassName='additionalClassName'
              searchText={searchText}
              onChangeSearchText={onChangeSearchText}
            />
          </div>
          <div className='waiting-room-table-with-toolbox-container charts-table-with-toolbox-container'>
            <div
              onScroll={onTableScrollHandler}
              ref={listInnerRef}
              className={classNames('availability-body-table', {
                'availability-body-table-without-pagination': !availabilitiesListTotalCount,
              })}
              style={availabilityTableBodyStyle}>
              {correctAvailabilityList?.length ? availabilityRibbonItems : emptyRibbon}
            </div>
          </div>
        </div>
        {!loading && availabilitiesListTotalCount ?
          <Pagination
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            className='availability-pagination'
            leftCount={paginationState.leftCount}
            rightCount={paginationState.rightCount}
            totalCount={availabilitiesListTotalCount}
            leftArrowAction={leftPaginationAction}
            rightArrowAction={rightPaginationAction}
          />
        : null}
      </div>
    </div>
  )
})

export default AvailabilityPage
